// src/components/AuthRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenExpired } from '../utils/auth';

const AuthRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  // If user is authenticated, redirect to home
  if (token && !isTokenExpired(token)) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default AuthRoute;